import React from "react";
import PropTypes from "prop-types";
import FormRange from "react-bootstrap/FormRange";
import FormControl from "react-bootstrap/FormControl";
import RiskScoreScale from "../../modules/samples/components/RiskScoreScale";

export default class RiskScoreSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      numberValue: props.value
    };
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.value) {
      this.setState({ value: this.props.value, numberValue: this.props.value });
    }
  }

  onChange = e => {
    this.props.onChange(e, this.props.permittedValues);
    this.setState({
      value: e.target.value
    });
  };

  onChangeNumber = e => {
    this.setState({
      numberValue: e.target.value
    });

    if (!e.target.value) {
      return;
    }

    this.onChange(e);
  };

  render() {
    const { min, max, step, name, classification, id } = this.props;
    const { value } = this.state;

    return (
      <div className="risk-score-slider">
        <div className="risk-score-slider__the-slider">
          <RiskScoreScale
            id={id}
            classification={classification}
            factor={parseInt(value, 10)}
          />
          <FormRange
            id={`${id}--risk-score-slider-input`}
            min={min}
            max={max}
            step={step}
            name={name}
            className={"number-range-combo"}
            value={this.state.value || this.props.value}
            onChange={this.onChange}
            data-testid="risk_score_range_slider"
          />
        </div>
        <FormControl
          id={`${id}--risk-score-slider-value`}
          min={min}
          max={max}
          step={step}
          name={name}
          className="number-range-combo risk-score-slider__the-number"
          as="input"
          type="number"
          value={this.state.numberValue}
          onChange={this.onChangeNumber}
          data-testid="risk_score_slider_input_value"
        />
      </div>
    );
  }
}

RiskScoreSlider.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  permittedValues: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  step: PropTypes.number,
  value: PropTypes.number,
  classification: PropTypes.string
};
